import script from "./InterCpeak.vue?vue&type=script&setup=true&lang=js"
export * from "./InterCpeak.vue?vue&type=script&setup=true&lang=js"

import "./InterCpeak.vue?vue&type=style&index=0&id=ce8b85be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce8b85be"]])

export default __exports__